export default "__VITE_ASSET__BOeL_E3G__"